import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";

const TextArea = () => {
  return (
    <div className="col-md-12 mt-3">
      <FloatingLabel controlId="textArea" label="Comments"/>
      <Form.Control
        as="textarea"
        placeholder="Konu Başlığı"
        style={{ height: "100px" }}
      />
    </div>
  );
};

export default TextArea;
